/**
 * Test IDs for QA automation.
 */
export const testIds = {
  multiSelectCustomFieldInputPicker: "multi-select-custom-field-input-picker",
  multiSelectCustomFieldInputSearch: "multi-select-custom-field-input-search",
} as const;
